import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { HomeImages } from '@nimbus-assistant/enums/home-images';
import { AssistantTasksService } from '@nimbus-assistant/services/assistant-tasks.service';
import { BannerService } from '@nimbus-assistant/services/banner.service';
import { UserStateService } from '@nimbus-assistant/services/user-state.service';

@Component({
  standalone: true,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule],
})
export class HomeComponent {
  private readonly preloadImg = new Image();
  public readonly state$ = this.userStateService.state$;
  public readonly hasBanner$ = this.taskBannerService.banner$.pipe(map((b) => !!b));
  public readonly hasParkedTasks$ = this.tasksService.parkedTasks$.pipe(map((t) => t.length > 0));

  public constructor(
    private readonly userStateService: UserStateService,
    private readonly taskBannerService: BannerService,
    private readonly tasksService: AssistantTasksService,
  ) {
    this.preloadImg.src = HomeImages.noConnectionImage;
  }
}
